import { render, staticRenderFns } from "./OrderTheList.vue?vue&type=template&id=05bb1ca2&"
import script from "./OrderTheList.vue?vue&type=script&lang=js&"
export * from "./OrderTheList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports